import React, { useState, useEffect } from 'react';
import './CommunicationChannels.css';

const CommunicationChannels = () => {

  const [columns, setColumns] = useState(window.innerWidth < 768 ? 1 : 2);

  useEffect(() => {
    const handleResize = () => {
      setColumns(window.innerWidth < 768 ? 1 : 2);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="communication-channels-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Multichannel Solution</h1>
          <p className="hero-description">Build and manage your customer interactions seamlessly across USSD, Shortcode, and WhatsApp — all in one platform.</p>
        </div>
        <div className="hero-background">
          <div className="circle-navy"></div>
          <div className="circle-light-blue"></div>
          <div className="circle-peach"></div>
        </div>
      </section>

      {/* USSD Section */}
      <section className="channel-section ussd-section">
      <h2 style={{ marginBottom:"30px",fontSize:"2rem" }}>USSD</h2>
        <div className="channel-container">
          <div className="channel-image">
            <img src="/images/ussd.jpg" alt="Person using USSD on mobile" />
          </div>
          <div className="channel-content">
            
            <p className="channel-tagline">Reach every mobile user – no internet needed.</p>
            <br></br>
            <div className="channel-description">
              <p>USSD, an acronym for Unstructured Supplementary Service Data, is a service that allows users with feature phones or smartphone devices to access services by dialling a code, e.g., *144#.</p>

              <a
                href="/contact-us" 
                target="_blank"
                rel="noopener noreferrer">
                <button className="sign-up-button-channel">Book a Demo→</button>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* USSD Key Features */}
      <section className="platform-section-data">
        <h2>Key Features</h2>
        <div className="features-grid-data">
          <div className="feature-card-data">
            <h3 style={{marginTop:"0px"}}>Easy Set Up</h3>
            <p>Design and deploy USSD applications with ease with our USSD Visual Builder. No technical expertise required.</p>
          </div>

          <div className="feature-card-data">
            <h3 style={{marginTop:"0px"}}>Seamless Integration</h3>
            <p>Connect your USSD flows with external systems effortlessly via our simple and reliable USSD API.</p>
          </div>

          <div className="feature-card-data">
            <h3 style={{marginTop:"0px"}}>Detailed Insights</h3>
            <p>Monitor, track, and manage all interactions seamlessly from one interface.</p>
          </div>
        </div>
      </section>

      {/* USSD Smart Ways */}
      <section className="smart-ways-ussd-section">
      <h2>Smart Ways to Use USSD</h2>
      
      <div className="use-cases-container">
        <div className="use-case-card">
          <div className="icon-container">
            <img src="/images/surveys.svg" alt="Surveys icon" className="use-case-icon" />
          </div>
          <p className="use-case-title">Surveys</p>
        </div>

        <div className="use-case-card">
          <div className="icon-container">
            <img src="/images/banking.svg" alt="Mobile Banking icon" className="use-case-icon" />
          </div>
          <p className="use-case-title">Mobile Banking</p>
        </div>

        <div className="use-case-card">
          <div className="icon-container">
            <img src="/images/request.svg" alt="Service Requests icon" className="use-case-icon" />
          </div>
          <p className="use-case-title">Service Requests</p>
        </div>

        <div className="use-case-card">
          <div className="icon-container">
            <img src="/images/tops.svg" alt="Airtime/Data Top-Ups icon" className="use-case-icon" />
          </div>
          <p className="use-case-title">Airtime/Data Top-Ups</p>
        </div>

        <div className="use-case-card">
          <div className="icon-container">
            <img src="/images/icons/refer.svg" alt="Account Registration icon" className="use-case-icon" />
          </div>
          <p className="use-case-title">Account Registration</p>
        </div>
      </div>
    </section>

      {/* Short Code Section */}
      <section className="channel-section short-code-section">
      <h2 style={{fontSize:"3rem",marginBottom:"20px"}}>Short Code</h2>
        <div className="channel-container">
          <div className="channel-image">
            <img src="/images/short-code.jpg" alt="People using short code on mobile" />
          </div>
          <div className="channel-content">
            <p className="channel-tagline">Engage customers instantly with short, memorable codes.</p>
            <br></br>
            <div className="channel-description">
            <p>Our Short Code services allow two-way SMS communication,</p>
            <p>enabling brands to run campaigns, offer support, </p>
            <p>and deliver time-sensitive alerts.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Short Code Key Features */}
      <section className="key-features-communication">
        <h3>Key Features</h3>
        <div className="features-grid-communication">
          <div className="feature-box-communication">
            <p>Easy to remember 5 digit Code</p>
          </div>
          <div className="feature-box-communication wide-box-communication">
            <p>Supports SMS Blasts and Two-Way Interactions</p>
          </div>
          <div className="feature-box-communication">
            <p>High Open Rates</p>
          </div>
          <div className="feature-box-communication">
            <p>Works On Any Mobile Device</p>
          </div>
        </div>
      </section>

      {/* Short Code Smart Ways */}
      <section className="smart-ways-short-code-section">
      <h2>Smart Ways to Use Short Code</h2>
      
      <div className="use-cases-container">
        <div className="use-case-card">
          <div className="icon-container">
            <img src="/images/gem.svg" alt="Promotions icon" className="use-case-icon" />
          </div>
          <p className="use-case-title">Promotions</p>
        </div>

        <div className="use-case-card">
          <div className="icon-container">
            <img src="/images/icons/refer.svg" alt="Lead Generation icon" className="use-case-icon" />
          </div>
          <p className="use-case-title">Lead Generation</p>
        </div>

        <div className="use-case-card">
          <div className="icon-container">
            <img src="/images/feedback.svg" alt="Customer Feedback icon" className="use-case-icon" />
          </div>
          <p className="use-case-title">Customer Feedback</p>
        </div>

        <div className="use-case-card">
          <div className="icon-container">
            <img src="/images/2fa.svg" alt="Two-Factor Authentication icon" className="use-case-icon" />
          </div>
          <p className="use-case-title">Two-Factor Authentication (2FA)</p>
        </div>

        <div className="use-case-card">
          <div className="icon-container">
            <img src="/images/alert.svg" alt="Alerts & Reminders icon" className="use-case-icon" />
          </div>
          <p className="use-case-title">Alerts & Reminders</p>
        </div>
      </div>
    </section>

      {/* WhatsApp Section */}
      <section className="channel-section whatsapp-section">
      <h2 style={{marginBottom:"20px", fontSize:"2rem"}}>WhatsApp for Business</h2>
        <div className="channel-container">
          <div className="channel-image">
            <img src="/images/whatsapp.jpg" alt="WhatsApp for Business icon" />
          </div>
          <div className="channel-content">
            <p className="channel-tagline">Communicate with your customers</p>
            <p className="channel-tagline">on the world's most</p>
            <p className="channel-tagline">popular messaging platform.</p>
            <br></br>
            <div className="channel-description">
            <p>Our WhatsApp Flow Bot is a business messaging tool designed to help you drive engagement with your customers. Design and deploy interactions with our visual builder. Send real-time updates, run customer surveys, offer customer support, lead generation and qualification.</p>

            <a
            href="/contact-us" 
            target="_blank"
            rel="noopener noreferrer">
              
            <button className="sign-up-button-channel">Get Started →</button>

            </a>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Key Features */}
      <section className="platform-section-data">
      <h2>Key Features</h2>
      <div
        className="features-grid-data"
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gridGap: '20px',
        }}
      >
        <div
          className="feature-card-data"
          style={{ padding: '1rem', border: '1px solid #e0e0e0', borderRadius: '8px' }}
        >
          <h3 style={{ marginTop: 0 }}>No-Code Platform</h3>
          <p>
            Our easy-to-use visual builder allows you to design user journeys and
            automate customer interactions without any coding skills.
          </p>
        </div>

        <div
          className="feature-card-data"
          style={{ padding: '1rem', border: '1px solid #e0e0e0', borderRadius: '8px' }}
        >
          <h3 style={{ marginTop: 0 }}>Broadcast Messages</h3>
          <p>
            Segment your customers and send personalised broadcasts to engage
            customers effectively.
          </p>
        </div>

        <div
          className="feature-card-data"
          style={{ padding: '1rem', border: '1px solid #e0e0e0', borderRadius: '8px' }}
        >
          <h3 style={{ marginTop: 0 }}>Secure messaging</h3>
          <p>
            Offer safer two-way communication to your customers and protect their
            privacy with hosted senders.
          </p>
        </div>

        <div
          className="feature-card-data"
          style={{ padding: '1rem', border: '1px solid #e0e0e0', borderRadius: '8px' }}
        >
          <h3 style={{ marginTop: 0 }}>Messaging templates</h3>
          <p>Craft interactive experiences with ready templates.</p>
        </div>
      </div>
    </section>


      {/* WhatsApp Smart Ways */}
      <section className="smart-ways-whatsapp-section">
      <h2>Smart Ways to Use WhatsApp Business</h2>
      
      <div className="use-cases-container">
        <div className="use-case-card">
          <div className="icon-container">
            <img src="/images/icons/customer.svg" alt="Customer Support icon" className="use-case-icon" />
          </div>
          <p className="use-case-title">Customer Support</p>
        </div>

        <div className="use-case-card">
          <div className="icon-container">
            <img src="/images/icons/order.svg" alt="Order Confirmation icon" className="use-case-icon" />
          </div>
          <p className="use-case-title">Order Confirmation</p>
        </div>

        <div className="use-case-card">
          <div className="icon-container">
            <img src="/images/icons/delivery.svg" alt="Status Updates icon" className="use-case-icon" />
          </div>
          <p className="use-case-title">Delivery Updates</p>
        </div>

        <div className="use-case-card">
          <div className="icon-container">
            <img src="/images/icons/feedback.svg" alt="Product Catalog icon" className="use-case-icon" />
          </div>
          <p className="use-case-title">Feedback Collection</p>
        </div>

        <div className="use-case-card">
          <div className="icon-container">
            <img src="/images/icons/marketing.svg" alt="Marketing Campaigns icon" className="use-case-icon" />
          </div>
          <p className="use-case-title">Marketing Campaigns</p>
        </div>
      </div>
    </section>
    </div>
  );
};

export default CommunicationChannels;